import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Death of DrnovÅ¡ek",
  "description": "",
  "published": "2008-02-23T00:00:00.000Z",
  "redirect_from": ["/blog/death-of-drnovek/swizec/126"],
  "categories": "food for thought",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last week rumours were spread like wildfire over the blogosphere of the slovenian internets about Drnovšek's death. They were untrue and, to be quite honest, rather audacious and a tad distasteful. Well as life would have it they were only untrue at the moment and it so happened that last night he passed away.`}</p>
    <p>{`Hokus pokus and the media goes into turmoil and devotes a lot of time to talking about this event and how good a man Drnovšek was and how much he's done for our politics and the general outlook of the country to the outside world. He was a good man, beyond doubt. And he looked like an alien, but we never held that against him.`}</p>
    <p>{`What I personaly find awfully disgusting about this whole thing is how a mere few months ago everyone was taking punches at him for wasting money on visiting his shamans and about how he isn't being a good role model to the common folk by going for alternative medicine. Not to mention the way he personally went to handle the whole Strojan situation. Oh we just could not get over htat one, a president, fighting with mere gypsies.`}</p>
    <p>{`Now that he's dead the situation has changed. He was the first president in the world to have the cohones for a formal visit with native americans, a brave man for showing his approval of alternative medicine despite his position and a very good guy for being able to lower to the level of common man to try and understand his problems and resolve a serious situation.`}</p>
    <p>{`Oh get a grip people! You disgust me! Look, the man is dead, it doesn't matter whether you think poorly of him or not, whether you say it or not. What matters is that now he's dead and we should pay him the respect he needs to be paid.`}</p>
    <p>{`Can't Drnovšek have some peace and quiet even in death?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      